import { useEffect, useMemo, useState } from "react"
import RadioGroup from "../../../components/Forms/RadioGroup"
import Modal, { ModalHead, ModalWrapper } from "../../../components/Modal"
import Table from "../../../components/Table"
import MainButton from "../../../components/templates/MainButton"
import SimpleCard from "../../../components/templates/SimpleCard"
import styles from './transactionDetail.module.scss'
import { PaymentMethodTypes } from "../../../utils/enums/paymentMethod"
import Radio3 from "../../../components/Forms/Radio3"
import Radio4 from "../../../components/Forms/Radio4"
import bankService from "../../../axios/services/bankService"
import toIDR from "../../../utils/helpers/toIDR"
import authService from "../../../axios/services/authService"
import { useSelector } from "react-redux"
import vaStyle from '../../Deposit/deposit.module.scss'
import CollapseCard from "../../../components/templates/CollapseCard"
import Button from "../../../components/Button"
import { toAbsoluteUrl } from "../../../utils/helpers/pathHelper"
import { copyTextToClipboard } from "../../../utils/helpers/copyTextToClipboard"
import { useToasts } from "react-toast-notifications"
import transactionService from "../../../axios/services/transactionService"
import nobuService from "../../../axios/services/nobuService"
import { useRouteMatch } from "react-router-dom"
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min"
// import SelectField from "../../../components/Forms/SelectField"

const bankList = [
  {
    logo: '/assets/media/banks/NOBU.png',
    bankName: 'Bank Nobu',
    virtualNumber: '12345678890123456',
    minimumTransfer: 'Rp 10000',
    howToTransfer: [
      {
        via: 'ATM',
        list: [
          "Masukan kartu ATM dan PIN Bank Nobu Anda",
          "Pilih menu Transaksi Lainnya",
          "Pilih menu Transfer ke Virtual Account",
          "Masukkan nomor Virtual Account yang tertera di atas",
          "Masukan nominal saldo yang ingin diisi",
          "Konfirmasi detail transaksi",
          "Ikuti instruksi selanjutnya untuk menyelesaikan transaksi"
        ]
      }
    ]
  },
  // {
  //   logo: '/assets/media/banks/BCA.png',
  //   bankName: 'Bank BCA',
  //   virtualNumber: '0987654321234567',
  //   minimumTransfer: 'Rp 10000',
  //   fee: 5000,
  //   howToTransfer: [
  //     {
  //       via: 'ATM',
  //       list: [
  //         "Masukan kartu ATM dan PIN BCA Anda",
  //         "Pilih menu Transaksi Lainnya",
  //         "Pilih menu ke Rek BCA Virtual Account",
  //         "Masukkan 12345 + nomor hp yang terdaftar pada aplikasi piro",
  //         "Input Virtual Account Number, misal. 88049XXXXXXXXXXX",
  //         "Masukan nominal saldo yang ingin diisi",
  //         "Ikuti instruksi selanjutnya untuk menyelesaikan transaksi"
  //       ]
  //     }
  //   ]
  // }
]


const PaymentMethod = ({ setStep, setCompletedTwo, items, data, setData }) => {
  const { params: { id } } = useRouteMatch();
  const { user, company } = useSelector(state => state.auth)
  const { addToast } = useToasts()
  const history = useHistory()
  const [showModal, setShowModal] = useState(false)
  const [processingFeeByBank, setProcessingFeeByBank] = useState(false)
  const [itemsFeeByBanks, setItemsFeeByBanks] = useState([])
  const [totalAmount, setTotalAmount] = useState(0)
  const [virtualAccountNumber, setVirtualAccountNumber] = useState('')
  const [generatingVA, setGeneratingVA] = useState(false)

  const submit = async () => {
    const _ = await transactionService.payment(id, {
      paymentMethod: data.paymentMethod
    })
    history.push("/");
  }

  const handleOpenModal = async () => {
    setShowModal(true)
    setGeneratingVA(true)
    
    try {
      // Generate VA dengan informasi transaksi
      const vaResponse = await nobuService.generateVA({
        virtualAccountName: `PIRO ${company.name || user.name}`,
        orderId: id,
        value: data.totalPayment.toString()
      })
      
      if (vaResponse.data.statusCode === 201) {
        setVirtualAccountNumber(vaResponse.data.data.virtualAccountNo)
        addToast('Virtual Account berhasil dibuat', { appearance: 'success' })
      } else {
        addToast('Gagal membuat Virtual Account', { appearance: 'error' })
      }
    } catch (error) {
      console.error('Error generating VA:', error)
      addToast('Gagal membuat Virtual Account', { appearance: 'error' })
    } finally {
      setGeneratingVA(false)
    }
  }

  const totalFeeTransfer = useMemo(() => itemsFeeByBanks.reduce((acc, cur) => acc + cur.amount, 0), [itemsFeeByBanks])

  useEffect(() => {
    setData(prev => ({ ...prev, totalPayment: totalAmount + totalFeeTransfer }))
  }, [totalFeeTransfer, totalAmount, setData])

  useEffect(() => {
    setProcessingFeeByBank(true)

    let banksObj = {}
    let totalAmount = 0
    items.forEach((el) => {
      if (!banksObj[el.bank]) banksObj[el.bank] = 1
      else banksObj[el.bank]++
      totalAmount += el.amount ?? 0
    });

    let banksArr = Object.keys(banksObj)
    bankService.list({ filter: banksArr })
      .then(({ data: { banks } }) => {
        banksArr = banksArr.map(el => {
          const fee = banks.find(bank => bank.artajasaCode === el).fee
          const count = banksObj[el]
          return {
            bank: el,
            fee,
            count,
            amount: +count * +fee
          }
        })

        setTotalAmount(totalAmount)
        setItemsFeeByBanks(banksArr)
      })
      .catch(() => { })
      .finally(() => {
        setProcessingFeeByBank(false)
      })
  }, [items])

  return (
    <SimpleCard className={styles.paymentMethod}>
      <div className={styles.subHeading}>
        <h5 className="font-size-16">Detail Transaksi dan Biaya</h5>
      </div>
      <Table
        data={itemsFeeByBanks}
        config={{
          columns: [
            {
              title: 'Bank Penerima', key: 'bank'
            },
            {
              title: 'Biaya Transfer', key: 'fee', render: v => `Rp${toIDR(v, false)}`
            },
            {
              title: 'Jumlah Transaksi', key: 'count'
            },
            {
              title: 'Subtotal', key: 'amount', align: 'right', render: v => `Rp${toIDR(v, false)}`
            }
          ],
          pagination: false,
          loading: processingFeeByBank
        }}
      />
      <div className={styles.total}>
        <table>
          <tbody>
            <tr>
              <td>Total Biaya Transfer</td>
              <td>Rp{toIDR(totalFeeTransfer, false)}</td>
            </tr>
            <tr>
              <td>Nominal Transfer</td>
              <td>Rp{toIDR(totalAmount, false)}</td>
            </tr>
            <tr>
              <td>Total</td>
              <td>Rp{toIDR(data.totalPayment ?? 0, false)}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr />
      <div className={styles.subHeading}>
        <h5 className="font-size-16">Pilih Metode Pembayaran</h5>
      </div>
      <RadioGroup
        row
        disabled
        value={data.paymentMethod}
        onChange={e => setData(prev => ({ ...prev, paymentMethod: e.target.value }))}
        className="mb-12"
      >
        <Radio3
          label="Virtual Akun"
          value={PaymentMethodTypes.BANK_TRANSFER}
        >
          {/* <p>Dikenakan biaya tambahan</p> */}
        </Radio3>
        {/* <Radio3
          label={PaymentMethodTypes.getStr(PaymentMethodTypes.BANK_TRANSFER)}
          value={PaymentMethodTypes.BANK_TRANSFER}
        >
          <SelectField
            variant="outlined"
            options={[
              {
                value: "tes1",
                label: "tes1"
              },
              {
                value: "tes2",
                label: "tes2"
              }
            ]}
          />
        </Radio3>
        <Radio3
          label={PaymentMethodTypes.getStr(PaymentMethodTypes.PAYLATER)}
          value={PaymentMethodTypes.PAYLATER}
        >
          <p>Transaksi sekarang bayarnya nanti</p>
        </Radio3> */}
      </RadioGroup>
      {/* {
        data.totalPayment > company.balance.deposit
        &&
        <div className={styles.errorSaldoLessThan}>
          <p>Saldo anda kurang dari total transaksi!</p>
        </div>
      } */}
      <hr />
      <div className={styles.footer}>
        <div className={styles.info}>
          <p>Dengan menekan tombol <span className="font-500">Kirim</span> saya sudah paham dengan <Link to="/verification/tnc-form" className="font-500 text-primary">
            Syarat & Ketentuan
            </Link> transfer Piro dan mengetahui transaksi yang sedang diproses tidak dapat dibatalkan</p>
        </div>
        <div className={styles.confirm}>
          <MainButton onClick={handleOpenModal}>Kirim</MainButton>
          <Modal in={showModal} onClose={() => setShowModal(false)}>
            <ModalWrapper>

              <p className="font-500 mb-12">Pilih Bank</p>
              <p className="text-dark-gray font-size-12 mb-24">Pilih jenis bank yang akan Anda gunakan untuk mengisi Deposit rekening Anda.</p>
              <div className={vaStyle.wrapper}>
                {bankList.map((v, index) => (
                  <CollapseCard
                    key={index}
                    className="mb-24"
                    withBorder
                    renderHeader={(
                      <div className="d-flex align-items-center overflow-hidden">
                        <img className="mr-24" width="100%" src={toAbsoluteUrl(v.logo)} alt="" />
                        <p className="ellipsis-text">{v.bankName}</p>
                      </div>
                    )}
                  >
                    <div className="py-24">
                      <div className="mb-18">
                        <h4 className="mb-18 font-size-16 text-dark-gray font-500">Nomor Akun Virtual :</h4>
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                          {generatingVA ? (
                            <div className="d-flex align-items-center">
                              <div className="spinner-border spinner-border-sm mr-8" role="status">
                                <span className="sr-only">Loading...</span>
                              </div>
                              <span>Generating Virtual Account...</span>
                            </div>
                          ) : (
                            <>
                              <h3 className="font-size-20 font-500">{virtualAccountNumber || 'VA Number not generated'}</h3>
                              {virtualAccountNumber && (
                                <Button
                                  onClick={() => copyTextToClipboard(
                                    virtualAccountNumber,
                                    () => addToast('Nomor VA berhasil disalin'),
                                    () => addToast('Nomor VA gagal disalin', { appearance: 'error' })
                                  )}
                                  className={vaStyle.btnCopy}
                                >
                                  Salin
                                </Button>
                              )}
                            </>
                          )}
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-6">
                            <p>Total <span className="text-primary font-500">{toIDR(data.totalPayment)}</span></p>
                          </div>
                          <div className="col-md-6">
                            <p>Biaya VA <span className="text-primary font-500">{toIDR(1500)}</span></p>
                          </div>
                        </div>
                      </div>
                      {v.howToTransfer.map((r, i) => (
                        <CollapseCard
                          key={i}
                          renderHeader={<p className="ellipsis-text">{r.via}</p>}
                        >
                          <div className="pb-24">
                            <ul className={vaStyle.howToTransfer}>
                              {r.list.map((d, idx) => (
                                <li key={idx}>
                                  <span>{idx + 1}</span>
                                  <p>{d}</p>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </CollapseCard>
                      ))}
                    </div>
                  </CollapseCard>
                ))}
              </div>

              {/* <ModalHead title="Kirim kode OTP melalui" onClose={() => setShowModal(false)} /> */}
              {/* <div className="py-26">
                <RadioGroup
                  value={data.otpMethod}
                  onChange={e => setData(prev => ({ ...prev, otpMethod: e.target.value }))}
                >
                  <Radio4
                    label="Email"
                    value="EMAIL"
                    optionalText={`(${user.email})`}
                  />
                  <Radio4
                    label="Phone"
                    value="SMS"
                    optionalText={`(${user.phoneNumber})`}
                  />
                </RadioGroup>
              </div> */}
              <MainButton className="w-100" onClick={submit}>Saya sudah transfer</MainButton>
            </ModalWrapper>
          </Modal>
        </div>
      </div>
    </SimpleCard >
  )
}

export default PaymentMethod
